import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.services";
import { TOAST_SUCCESS } from "../../config/common";

export const getProductListApiCall = createAsyncThunk("productList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: productList } = await API.getProductListAPI(submitData);
        dispatch(setLoader(false))
        return productList;
    } catch (error) {
        throw error;
    }
});

export const editProductDataApiCall = createAsyncThunk("editProductData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: editProductData, code, message } = await API.editProductDataAPI(submitData);
        if (code === '1') {
            TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editProductData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    productList: {
        data: [],
        error: null,
    },
    editProductData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const productSlice = createSlice({
    name: "PRODUCT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProductListApiCall.fulfilled, (state, action) => {
                state.productList.data = action.payload;
            })
            .addCase(getProductListApiCall.rejected, (state, action) => {
                state.productList.error = action.error.message;
            })
            .addCase(editProductDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editProductData.data = data;
                state.editProductData.message = message;
                state.editProductData.code = code;
            })
            .addCase(editProductDataApiCall.rejected, (state, action) => {
                state.editProductData.error = action.error.message;
            });
    },
});

export default productSlice.reducer;